<div class="container-fluid">
    <div class="row">
      <div class="col-md-12 ">
        <div class="card">
          <div class="card-header text-center">
            <p class="h4  float-left">Lista de visitas</p>
            <a (click)="createVisita()" class="btn btn-success float-right">
              Crear visita</a
            >

            <button
 
            (click)="crearPDF()"
            class="btn btn-primary"
           >
            <i class="fa fa-print"></i>
           </button>
          </div>
          <div class="card-body">
            <div class="row">
             
              <div class="col-md-6">
                <!-- <select
                          class="custom-select"
                          id="inputGroupSelect02"
                          (change)="onChange($event.target.value)"
                        >
                          <option value="">Seleccione Vendedor</option>
                          <option
                            *ngFor="let vendedor of users"
                            [value]="vendedor.id"
                          >
                            {{ vendedor.nombres }} {{ vendedor.apellidos }}</option
                          >
                        </select> -->
              </div>
            </div>
  
            <br />
  
            <div class="row">
              <div class="col-md-3" *ngFor="let visita of visitas; let i = index">

                <div class="card3" >
                  <div class="calendar">
                    <div class="month background">{{visita.fecha |date:'MMMM'}}  <button
                      type="button"
                      class="btn btn-default btn-sm"
                      (click)="eliminar(visita.id)"
                    >
                      <i
                        class="fa fa-trash text-danger"
                        style="font-size: 20px"
                      ></i>
                    </button></div>
                    <div class="day"></div>
                    <div class="date">{{visita.fecha |date:'dd'}}  </div>
                    <div  class="texto">
                      <span style="font-size: 12px;">{{visita.cliente.entidad}}</span><br>
                      <span style="font-size: 12px;"> {{visita.cliente.nombres}}    {{visita.cliente.apellidos}}</span><br>
                      <span style="font-size: 11px;">  {{visita.detalle}}</span>
                    </div>

                    <div class="time background">{{visita.hora}} </div>
                  </div>
                </div>
              
  
                <!-- <p>
                    Mostrando clientes 
                  </p>
                  <p>
                    Página
                  </p> -->
                <!-- <input type="number" style="width: 50px;"
                  [(ngModel)]="paginanum" name="home" required min="0" step="1">
                  <button (click)="searchPage(paginanum)" >
                   ir
                 </button> -->
                <br />
                <!-- <button (click)="prevPage()" [disabled]="!clientes.prev_page_url">
                    Anterior
                  </button>
                  <button (click)="nextPage()" [disabled]="!clientes.next_page_url">
                    Siguiente
                  </button> -->
              </div>
            </div>
            <!-- <p *ngIf="clientService.isLoading">Cargando...</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  